import { OrderState } from "../entity/Order";
import { COLORS } from "../utils/Colors";

export const getStatusColor = (status: OrderState) => {
  switch (status) {
    case OrderState.PENDING:
      return COLORS.OrderState.PENDING;
    case OrderState.CONFIRMED:
      return COLORS.OrderState.CONFIRMED;
    case OrderState.DELIVERED:
      return COLORS.OrderState.Delivered;
    case OrderState.CANCELED:
      return COLORS.OrderState.Canceled;
    case OrderState.RETURNED:
      return COLORS.OrderState.Returned;
    case OrderState.UPLOADED:
      return COLORS.OrderState.UPLOADED;
    case OrderState.EXCHANGED:
      return COLORS.OrderState.EXCHANGED;
    case OrderState.IN_TRANSIT:
      return COLORS.OrderState.IN_TRANSIT;
    case OrderState.OUT_FOR_DELIVERY:
      return COLORS.OrderState.OUT_FOR_DELIVERY;
    case OrderState.SHIPPED:
      return COLORS.OrderState.SHIPPED;
    case OrderState.TENTATIVE:
      return COLORS.OrderState.TENTATIVE;

    default:
      return "gray";
  }
};

export const getStatusTextColor = (status: OrderState) => {
  switch (status) {
    case OrderState.PENDING:
      return COLORS.OrderStatusText.PENDING;
    case OrderState.CONFIRMED:
      return COLORS.OrderStatusText.CONFIRMED;
    case OrderState.DELIVERED:
      return COLORS.OrderStatusText.DELIVERED;

    case OrderState.CANCELED:
      return COLORS.OrderStatusText.CANCELED;
    case OrderState.RETURNED:
      return COLORS.OrderStatusText.RETURNED;
    case OrderState.UPLOADED:
      return COLORS.OrderStatusText.UPLOADED;
    case OrderState.EXCHANGED:
      return COLORS.OrderStatusText.EXCHANGED;
    case OrderState.IN_TRANSIT:
      return COLORS.OrderStatusText.IN_TRANSIT;
    case OrderState.OUT_FOR_DELIVERY:
      return COLORS.OrderStatusText.OUT_FOR_DELIVERY;
    case OrderState.SHIPPED:
      return COLORS.OrderStatusText.SHIPPED;
    case OrderState.TENTATIVE:
      return COLORS.OrderStatusText.TENTATIVE;

    default:
      return "gray";
  }
};
